<template>
  <div
    @click="clickAway(link)"
    class="
      animate__animated animate__fadeInDown
      card
      p-5
      w-full
      cursor-pointer
      rounded-lg
      hover:bg-gray-800 hover:shadow-lg
      border-b-4 border-green-600
      hover:text-white hover:border-gray-800 hover:border hover:underline
    "
  >
    <div class="flex flex-col">
      <div class="text-xl font-bold">
        <fa :icon="icon" class="mr-2" :class="computedColor"></fa>{{ title }}
      </div>
      <div class="text-sm">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "icon", "description", "iconColor", "link"],
  name: "link-card",
  computed: {
    computedColor: function () {
      if (this.iconColor == undefined) {
        return "text-gray-500";
      }
      return this.iconColor;
    },
  },
  methods: {
    clickAway(url) {
      if (typeof url === "function") {
        url();
        return;
      }
      if (url == undefined || url == null) {
        return;
      }
      window.open(url, "_blank");
    },
  },
};
</script>

<style>
</style>